// packages/content/src/strings/surfaces.ts
import type { StringBank } from '../schema/strings';
export default {
  creamPlain: 'Plain cream wallpaper', sageSprig: 'Sage sprig wallpaper', peachStripe: 'Peach stripe wallpaper', skyDots: 'Sky dot wallpaper',
  mintGingham: 'Mint gingham wallpaper', honeyDiamonds: 'Honey diamond wallpaper', lilacBloom: 'Lilac bloom wallpaper', roseChecks: 'Rose check wallpaper',
  oakPlanks: 'Oak plank floor', walnutPlanks: 'Walnut plank floor', creamTiles: 'Cream tile floor', tealCarpet: 'Teal carpet',
  honeyHerringbone: 'Honey herringbone floor', slateChecks: 'Slate check floor', sandTiles: 'Sand tile floor', mossCarpet: 'Moss carpet',
} as const satisfies StringBank;
